module.exports = __webpack_public_path__ + "static/media/office_powerpoint.4b0789f4.svg";